export const inputClass = `w-full border rounded-lg bg-gray-50 text-black p-4 mt-1`;
export const darkInputClass = `${inputClass} bg-violet`;

/** Título de seção do rebranding (Meu perfil e listas de reconhecimento), transcrito do design. */
export const TITULO_DE_SECAO = 'm-0 font-display text-xl font-bold text-brand-blue-dark';
